import { mapState } from 'vuex'
import {
  Request
} from '../shared/base.requests'
import config from '../../config/customer.api'
export default {
  computed: {
    ...mapState({
      page: state => state.about.page,
      pageEnum: state => state.about.pagesEnum,
      customization: state => state.common.customization
    }),
    photoGallerySrc () {
      if (this.photos && this.photos.length) {
        return this.photos.map(x => {
          if (x.imageUrl) {
            return x.imageUrl
          }
          return x
        })
      } else {
        return []
      }
    },
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }

  },
  methods: {
    openPhotoBrowser (currentImageIndex) {
      this.$refs.pb = window.f7.photoBrowser({
        swipeToClose: false,
        photos: this.photoGallerySrc,
        theme: 'dark',
        onClose: this.photoBrowserClosed
      })
      this.$refs.pb.open(currentImageIndex)
    },
    photoBrowserClosed () {
      this.$refs.pb = null
    },
    setMedia () {
      this.isMedia = true
      this.isBio = false
      this.isSocial = false
      this.activeTabUsage = 0
    },
    setBio () {
      this.isMedia = false
      this.isBio = true
      this.isSocial = false
      this.activeTabUsage = -100
    },
    setSocial () {
      this.isMedia = false
      this.isBio = false
      this.isSocial = true
      this.activeTabUsage = -200
    },
    LogActivity (type) {
      Request.get(config.socialActivityLog + type)
    },
    updateTabs () {
      if (this.page === this.pageEnum.Media) {
        this.isMedia = true
        this.activeTabUsage = 0
      }
      if (this.page === this.pageEnum.Bio) {
        this.isBio = true
        this.activeTabUsage = -100
      }
      if (this.page === this.pageEnum.Socials) {
        this.isSocial = true
        this.activeTabUsage = -200
      }
    },
    changeImageView (id) {
      this.imageViewId = id
    }
  },

  data () {
    let rndID = Math.round(Math.random() * 1000).toString()
    return {
      tabMedia: 'tab-media' + rndID,
      tabBio: 'tab-bio' + rndID,
      tabSocial: 'tab-social' + rndID,
      imageViewId: 2,
      isMedia: false,
      isBio: false,
      isSocial: false,
      activeTabUsage: 0,
      index: 0,
      show: false,
      currentImageIndex: 0,
      initPhotoBrowser: false
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/mixins/about.common.mixin.js